/* src/app/ships/bulk-cards/marines/marines-bulk-enrollment/marines-bulk-enrollment.component.css */
.decrypting-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 70vh;
  z-index: 100001;
  opacity: .50;
  background-color: #fff;
}
.decrypting-content {
  position: absolute;
  top: 0;
  height: 70vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100002;
}
input[type=file] {
  color: transparent;
}
.info-msg {
  padding: 1rem;
  font-size: 11pt;
}
.upload {
  padding: 1rem;
}
.error-msg {
  color: red;
  padding: 1rem;
  margin: 1rem;
  font-size: 14pt;
}
strong.danger {
  color: red;
}
tr.bordered {
  border: 1px solid #555;
}
div.output {
  background-color: #fff;
}
.fileUpload {
  z-index: 100000;
  margin: 1rem;
  padding: 1rem;
}
.output {
  width: 100%;
  overflow-x: auto;
  margin: .75rem;
}
.output table thead th {
  padding-right: .8rem;
  padding-left: .2rem;
}
.btn {
  display: block;
  margin: .5rem;
}
td {
  padding-left: .2rem;
  padding-right: 1rem;
}
td i.fa {
  font-size: 1.1rem;
}
td i.fa-times {
  color: red;
}
td i.fa-check {
  color: green;
}
.missing-info-msg {
  padding: 0 .75rem 0 .75rem;
  font-size: 14pt;
}
.missing-info-msg i {
  color: red;
}
.cancel {
  margin-top: .5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.upload-success {
  text-align: center;
  margin: 0 auto;
  border: 2px solid green;
  padding: 2rem;
  width: 500px;
  max-width: 100%;
  overflow: auto;
}
/*# sourceMappingURL=marines-bulk-enrollment.component.css.map */
